/** Compete Pages product favicon (matches public/marketing pages). */
export const PLATFORM_FAVICON_HREF = '/compete-pages-icon.svg';

const ICON_LINK_ID = 'dynamic-favicon';
const SHORTCUT_LINK_ID = 'dynamic-shortcut-icon';

function getOrCreateLink(id: string, rel: string): HTMLLinkElement {
  let link = document.getElementById(id) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = id;
    link.rel = rel;
    document.head.appendChild(link);
  }
  return link;
}

/**
 * Apply the Compete Pages favicon to the current document (builder, dashboard, login, etc.).
 */
export function applyPlatformFavicon(): void {
  const icon = getOrCreateLink(ICON_LINK_ID, 'icon');
  icon.href = PLATFORM_FAVICON_HREF;
  icon.type = 'image/svg+xml';

  const shortcut = getOrCreateLink(SHORTCUT_LINK_ID, 'shortcut icon');
  shortcut.href = PLATFORM_FAVICON_HREF;
  shortcut.type = 'image/svg+xml';

  // Head-content / preview may add extra icon links — keep them aligned on platform surfaces.
  document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach(el => {
    const link = el as HTMLLinkElement;
    if (link.id === ICON_LINK_ID || link.id === SHORTCUT_LINK_ID) return;
    link.href = PLATFORM_FAVICON_HREF;
    if (link.rel === 'icon') {
      link.type = 'image/svg+xml';
    }
  });
}

/**
 * Apply a customer site's favicon (page preview, published site viewer in SPA, etc.).
 */
export function applySiteFavicon(faviconUrl: string): void {
  const icon = getOrCreateLink(ICON_LINK_ID, 'icon');
  icon.href = faviconUrl;
  icon.removeAttribute('type');

  const shortcut = getOrCreateLink(SHORTCUT_LINK_ID, 'shortcut icon');
  shortcut.href = faviconUrl;
  shortcut.removeAttribute('type');
}
